import React from "react";

/*
Example of what type of data is expected

"pricingFormatted": {
    "SCAN": [
        ["1", "$1.35 per page", "$1.35 per page"],
        ["2+", "+ $.9 per page", "+ $.59 per page"],
    ],
    "COPY": [
        ["1", "$.99 per page", "$1.19 per page"],
        ["2 - 5", "+ $.39 per page", "+ $.99 per page"],
        ["6 - 15", "+ $.29 per page", "+ $.89 per page"],
        ["16+", "+ $.19 per page", "+ $.69 per page"],
    ],
    "FAX": [
        ["1", "$1.79 per page", "$1.79 per page"],
        ["2+", "+ $.99 per page", "+ $.99 per page"],
    ],
    "PRINT": [
        ["1", "$.99 per page", "$1.19 per page"],
        ["2 - 5", "+ $.39 per page", "+ $.89 per page"],
        ["6 - 10", "+ $.29 per page", "+ $.79 per page"],
        ["11+", "+ $.19 per page", "+ $.59 per page"],
    ],
},
*/

const pricingIcon = (color) => {
  if (color) {
    return (
      <img
        src="https://s3.amazonaws.com/printwithme.com/assets/img/color-icon.png"
        style={{ height: "2rem" }}
      />
    );
  }

  return (
    <img
      src="https://s3.amazonaws.com/printwithme.com/assets/img/bw.png"
      style={{ height: "2rem" }}
    />
  );
};

export const Pricing = ({ type, children }) => {
  return (
    <section>
      <div className="mt-4 mb-5">
        <h2 className="text-center text-sm-start">{type} Pricing and Rates</h2>
      </div>

      <div className="d-flex justify-content-center flex-wrap">{children}</div>
    </section>
  );
};

export const PricingPanel = ({ pricingFormatted, color }) => {
  return (
    <article className="pricing-panel">
      <header className="text-center fw-bold pt-4">
        {pricingIcon(color)}
        <span className="ps-2">{color ? "Color" : "B&W"}</span>
      </header>

      <section className="py-4">
        <div className="row text-center">
          <b className="col">Page</b>
          <b className="col">Cost</b>
        </div>

        {pricingFormatted.map((p, idx) => {
          let page = p[0];
          let cost = color ? p[2] : p[1];

          return (
            <div className="row text-center" key={idx}>
              <p className="col py-2">{page}</p>
              <p className="col py-2">{cost}</p>
            </div>
          );
        })}
      </section>
    </article>
  );
};

export const PricingMessage = ({ credits }) => {
  return (
    <div className="mt-3">
      <p>
        Prices above reflect this location only and does not reflect discounts
        or promotions.
      </p>
      {credits.display ? (
        <p>
          You must pre-load your account with value in increments of $
          {credits.increments}.{" "}
          <a
            style={{ fontSize: ".75rem" }}
            href="https://printwithme.com/help-center/printwithme-credits/"
            target="_blank"
          >
            Click for more information.
          </a>
        </p>
      ) : null}
    </div>
  );
};
